import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 6.45833V9.375M7.74518 15.403L9.46606 16.8455C9.77436 17.104 10.2233 17.1053 10.533 16.8486L12.2816 15.4C12.4311 15.2761 12.6191 15.2083 12.8133 15.2083H15.2083C16.1288 15.2083 16.875 14.4621 16.875 13.5417V4.79167C16.875 3.87119 16.1288 3.125 15.2083 3.125H4.79167C3.87119 3.125 3.125 3.87119 3.125 4.79167V13.5417C3.125 14.4621 3.87119 15.2083 4.79167 15.2083H7.20985C7.40562 15.2083 7.59515 15.2773 7.74518 15.403Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 11.4584H10.0083",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }